'use strict';

var getIndent = function getIndent(indent) {
  return typeof indent === 'number' ? ' '.repeat(indent) : indent;
};

module.exports = exports = function stringify(arg, opts) {
  if (Array.isArray(arg)) {
    return stringifyBlocks(arg, opts);
  }

  if (arg && typeof arg === 'object') {
    if ('tag' in arg) {
      return stringifyTag(arg, opts);
    }

    if ('tags' in arg) {
      return stringifyBlock(arg, opts);
    }
  }

  throw new TypeError('Unexpected argument passed to `stringify`.');
};

var stringifyBlocks = exports.stringifyBlocks = function stringifyBlocks(blocks) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$indent = _ref.indent,
      indent = _ref$indent === void 0 ? '' : _ref$indent;

  var indnt = getIndent(indent);
  return blocks.reduce(function (s, block) {
    return s + stringifyBlock(block, {
      indent: indent
    });
  }, (indnt ? indnt.slice(0, -1) : '') + '/**\n') + indnt + '*/';
};

var stringifyBlock = exports.stringifyBlock = function stringifyBlock(block) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$indent = _ref2.indent,
      indent = _ref2$indent === void 0 ? '' : _ref2$indent;

  // block.line
  var indnt = getIndent(indent);
  return (block.description ? "".concat(indnt, "* ").concat(block.description, "\n").concat(indnt, "*\n") : '') + block.tags.reduce(function (s, tag) {
    return s + stringifyTag(tag, {
      indent: indent
    });
  }, '');
};

var stringifyTag = exports.stringifyTag = function stringifyTag(tag) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$indent = _ref3.indent,
      indent = _ref3$indent === void 0 ? '' : _ref3$indent;

  var indnt = getIndent(indent);
  var type = tag.type,
      name = tag.name,
      optional = tag.optional,
      description = tag.description,
      tagName = tag.tag,
      deflt = tag.default;
  return indnt + "* @".concat(tagName) + (type ? " {".concat(type, "}") : '') + (name ? " ".concat(optional ? '[' : '').concat(name).concat(deflt ? "=".concat(deflt) : '').concat(optional ? ']' : '') : '') + (description ? " ".concat(description.replace(/\n/g, '\n' + indnt + '* ')) : '') + '\n';
};